import * as React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import UnfoldMoreIcon from '@mui/icons-material/UnfoldMore';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import { visuallyHidden } from '@mui/utils';
import { animalAssets, financeAssets } from '../../../services/constant';
import DetailModal from './detailModal';
import ConfirmModal from './confirmModal';
import { Popover, Typography } from '@mui/material';
import { useState } from 'react';
import CustomPagination from './pagination';
import { Download } from '@mui/icons-material';
function createData(id, date, name, nif, price, status) {
  return {
    id,
    date,
    name,
    nif,
    price,
    status
  };
}

const rows = [
  createData(1, '21-09-2025 às 12:00 ', 'Consulta, 2 Antissépticos e Desinfetantes...', 2221459, '45€', 2),
  createData(2, '21-09-2025 às 14:30 ', 'Raios-X e ultrassonografia', 1200405, '30€', 2),
  createData(3, '20-09-2025 às 09:10 ', 'Tosquia e banho', 3249911, '15€', 0),
  createData(4, '15-09-2025 às 16:00 ', 'Consulta', 4099405, '35€', 0),
  createData(5, '03-09-2025 às 09:35 ', 'Consulta', 4099405, '35€', 0),
  createData(6, '03-09-2025 às 10:00 ', 'Consulta', 4099405, '35€', 0),
  createData(7, '22-07-2025 às 15:30 ', 'Consulta', 4099405, '35€', 1),

];

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

const headCells = [
  {
    id: 'date',
    numeric: false,
    disablePadding: true,
    label: 'Data da visita',
  },
  {
    id: 'name',
    numeric: false,
    disablePadding: false,
    label: 'Consumo',
  },
  {
    id: 'nif',
    numeric: true,
    disablePadding: false,
    label: 'NIF',
  },
  {
    id: 'price',
    numeric: true,
    disablePadding: false,
    label: 'Total da despes',
  },
  {
    id: 'status',
    numeric: false,
    disablePadding: false,
    label: 'Estado/Ações',
  },
];

function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>

        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={'left'}
            padding="0px"
            sortDirection={orderBy === headCell.id ? order : false}
            style={{ fontSize: '12px', fontWeight: '500', fontFamily: 'Roboto', color: '#95AFC9', paddingTop:'0px !important' }}
          >
            <TableSortLabel
              // active={orderBy === headCell.id}
              hideSortIcon
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
              style={{ borderRight: '1px solid #95AFC9', width: "100%", display: 'flex', flexDirection: 'row', paddingRight: '0.5rem', justifyContent: 'space-between' }}
            >
              {headCell.label}

              {/* <Box component="span" sx={visuallyHidden}>
                {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
              </Box> */}
              <UnfoldMoreIcon />
            </TableSortLabel>
          </TableCell>
        ))}
        <TableCell
          align={'right'}
          padding='0px'
          style={{ fontSize: '12px', fontWeight: '500', fontFamily: 'Roboto', color: '#95AFC9' }}
        >
          <CustomPagination
            currentPage={1} // Your current page state
            totalPages={1} // Total number of pages
            onPageChange={(page) => console.log('Page changed to:', page)} // Replace with your handler
          />
        </TableCell>
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
};

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    backgroundColor: theme.palette.action.hover,
  },
  // hide last border
  '&:last-child td, &:last-child th': {
    border: 0,
  },
}));

export default function TranscationTable({ refund, setRefund, details, setDetails, setShowAll, showAll, expend, setExpend }) {
  const [order, setOrder] = React.useState('asc');
  const [orderBy, setOrderBy] = React.useState('calories');
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(7);

  const [confirm, setConfirm] = React.useState(false);
  const [openPopUpId1, setOpenPopUpId1] = React.useState(null);
  const [anchorElValue, setAnchorElValue] = React.useState(null);
  const [iconvalue, setIconvalue] = React.useState(null);

  const tableRef = React.useRef(null);
  const [popoverWidth, setPopoverWidth] = useState(0);

  React.useEffect(() => {
    if (tableRef.current) {
      setPopoverWidth(tableRef.current.offsetWidth);
    }
  }, [tableRef.current]);


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelected = rows.map((n) => n.id);
      setSelected(newSelected);
      return;
    }
    setSelected([]);
  };

  const handleClick = (event, id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }
    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  const visibleRows = React.useMemo(
    () =>
      [...rows]
        .sort(getComparator(order, orderBy))
        .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage),
    [order, orderBy, page, rowsPerPage],
  );

  const detailModal = () => {
    setDetails(true);
  }

  const handlePopUpCloseValue = () => {
    setAnchorElValue(null);
    setOpenPopUpId1(null);
    setIconvalue(null);
  };

  const handlPopUpValue = (e, id) => {
    setAnchorElValue(e.currentTarget);
    setOpenPopUpId1(id);
    setIconvalue(id);
  };
  return (
    <div className='bg-white rounded-[16px] mr-[43px] px-[21px] pt-[14px] pb-[32px] overflow-y-scroll' style={{ height: 'calc(100vh - 330px)' }}>
      <TableContainer ref={tableRef}>
        <Table
          aria-labelledby="tableTitle"
        >
          <EnhancedTableHead
            numSelected={selected.length}
            order={order}
            orderBy={orderBy}
            onSelectAllClick={handleSelectAllClick}
            onRequestSort={handleRequestSort}
            rowCount={rows.length}
          />
          <TableBody>
            {visibleRows.map((row, index) => {
              const isItemSelected = selected.includes(row.id);
              const labelId = `enhanced-table-checkbox-${index}`;

              return (
                <StyledTableRow
                  hover
                  onClick={(event) => handleClick(event, row.id)}
                  aria-checked={isItemSelected}
                  tabIndex={-1}
                  key={row.id}
                  padding={row.status === 2 ? '4px' : '8px'}

                  sx={row.status === 2 && !refund ? {borderBottom:'3px solid white', cursor: 'pointer', background: '#FEF3D1 !important', marginBottom: '4px' } : {borderBottom:'3px solid white', cursor: 'pointer', marginBottom: '4px' }}
                >


                  <TableCell
                    component="th"
                    id={labelId}
                    scope="row"
                    style={{ color: '#697DA4', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '500' }}
                  >
                    {row.date}
                  </TableCell>
                  <TableCell style={{ color: '#2E436C', fontSize: '13px', fontFamily: 'Roboto', fontWeight: '600' }} >{row.name}</TableCell>
                  <TableCell style={{ color: '#697DA4', fontSize: '14px', fontFamily: 'Roboto', fontWeight: '500' }} >{row.nif}</TableCell>
                  <TableCell style={{ color: '#29215B', fontSize: '16px', fontFamily: 'Roboto', fontWeight: '500' }} >{row.price}</TableCell>
                  <TableCell >{row.status === 2 ? (
                    !refund ?
                      (<button className='flex flex-row gap-[8px] hover:text-[#29215B]  text-[#FBBD18]' onClick={() => detailModal()}>
                        <Download className='w-[13px] h-[14px]  '/>
                        {/* <img src={financeAssets.ic_download} className='w-[13px] h-[14px]' alt='' /> */}
                        <span className='font-14-700  '>Pedir Reembolso</span>
                      </button>)
                      :
                      (
                        <button className='flex flex-col gap-0'>
                          <p className='font-13-700 text-[#FBBD18] leading-0'>A aguardar reembolso</p>
                          <p className='font-12-400 text-[#697DA4]'>desde 10-09-2024 às 12:34</p>
                        </button>
                      )
                  )
                    : row.status === 0 ?
                      (<div className='flex flex-row gap-[8px]'>
                        <img src={financeAssets.ic_complete} className='w-[12px] h-[12px] self-center' alt='' />
                        <span className='font-14-400 text-[#29215B]'>Recebido</span>
                      </div>)
                      :
                      (<div className='flex flex-row gap-[8px]'>
                        <img src={financeAssets.ic_error} className='w-[12px] h-[12px] self-center' alt='' />
                        <span className='font-14-400 text-[#29215B]'>Rejeitado</span>
                      </div>)}
                  </TableCell>
                  <TableCell align='right'> <button className='bg-none border-none' onClick={(e) => handlPopUpValue(e, row.id)}> <img src={iconvalue === row.id ? financeAssets.ic_info_active : financeAssets.ic_info} className='w-[12px] h-[12px]' alt='' /> </button></TableCell>

                  <Popover
                    id={row.id}
                    open={openPopUpId1 === row.id}
                    anchorEl={anchorElValue}
                    onClose={handlePopUpCloseValue}
                    anchorOrigin={{
                      vertical: 'bottom',
                      horizontal: 'right',
                    }}
                    transformOrigin={{
                      vertical: 'top',
                      horizontal: 'right',
                    }}
                    sx={{
                      marginTop: '2rem',
                      '& .MuiPaper-root': {
                        border: '1px solid #fff',
                        borderRadius: '1.1rem',
                        minWidth: `${popoverWidth - 32}px`,
                        boxShadow: '0px 0px 23px 0px rgba(0, 0, 0, 0.15)',
                      },
                    }}
                  >
                    <Typography className="flex-column" style={{ padding: '2rem', width: '100%' }}>
                      <div className='flex flex-col'>
                        <div className='flex flex-row py-[10px] justify-between'>
                          <p className='font-16-500 font-color'>Consultas de Rotina</p>
                          <div className='flex flex-row font-color'>
                            <span className='border-l-[1px] pl-6 font-13-400 flex flex-row'>
                              PVP:
                              <span className='font-15-700 mx-4'>40€</span>
                              Copag:
                              <span className='font-15-700 mx-4'>35€</span>
                              Copag./seguradora:
                              <img alt='' className='w-[15px] h-[15px] mx-6 self-center' src={animalAssets.ic_eye_active} />
                            </span>

                            <span className='border-l-[1px] pl-4 font-13-400'>
                              Data:
                              <span className='font-13-500 mx-8'>10 - 09 - 2024</span>
                              Qt:
                              <span className='font-13-500 mx-8'>1</span>
                            </span>
                          </div>
                        </div>

                        <div className='flex flex-row pt-[20px]  justify-between border-t-[1px]'>
                          <p className='font-16-500 font-color'>Antissépticos e Desinfetantes</p>
                          <div className='flex flex-row font-color'>
                            <span className='border-l-[1px] pl-6 font-13-400 flex flex-row'>
                              PVP:
                              <span className='font-15-700 mx-4'>15€</span>
                              Copag:
                              <span className='font-15-700 mx-4'>10€</span>
                              Copag./seguradora:
                              <img alt='' className='w-[15px] h-[15px] mx-6 self-center' src={animalAssets.ic_eye_active} />
                            </span>

                            <span className='border-l-[1px] pl-4 font-13-400'>
                              Data:
                              <span className='font-13-500 mx-8'>10 - 09 - 2024</span>
                              Qt:
                              <span className='font-13-500 mx-8'>2</span>
                            </span>
                          </div>
                        </div>


                      </div>
                    </Typography>
                  </Popover>
                </StyledTableRow>
              );
            })}
            {emptyRows > 0 && (
              <TableRow
                style={{
                  height: (dense ? 33 : 53) * emptyRows,
                }}
              >
                <TableCell colSpan={6} />
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <TablePagination
        rowsPerPageOptions={[7, 10, 25]}
        component="div"
        count={rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      /> */}
      <DetailModal details={details} setDetails={setDetails} setConfirm={setConfirm} setRefund={setRefund} setShowAll={setShowAll} showAll={showAll} expend={expend} setExpend={setExpend} />
      <ConfirmModal confirm={confirm} setConfirm={setConfirm} setRefund={setRefund} />
    </div>
  );
}
